import React from 'react';
import cn from 'classnames';

import { Collapsible } from 'components/shared/Collapsible';
import { Table } from 'components/shared/Table';
import { Typography } from 'components/shared/Typography';

import { importedAdminsTypes } from './UploadResultsStep.config';

import { getAdminsTableColumns } from './UploadResultsStep.tableConfig';

import { UploadResultHeader } from '../UploadResultHeader';

import styles from './UploadResultsStep.module.scss';

const cellRenderer = (
  {
    item,
    key,
    minWidth,
    maxWidth,
  }: { item: any; key: any; minWidth: any; maxWidth: any },
  DefaultCell: any,
) => {
  switch (key) {
    case 'admin': {
      return (
        <div
          className={styles.adminCell}
          key={key}
          style={{ minWidth, maxWidth }}
        >
          <Typography
            className={styles.adminName}
            variant="body2"
            mode="compact"
          >
            {item.name}
          </Typography>
          <Typography
            className={styles.adminEmail}
            variant="body3"
            mode="compact"
          >
            {item.email}
          </Typography>
        </div>
      );
    }
    case 'row': {
      return (
        <div
          className={styles.rowCell}
          key={key}
          style={{ minWidth, maxWidth }}
        >
          <Typography variant="body2" mode="compact" weight="medium">
            {item.row}
          </Typography>
        </div>
      );
    }
    default: {
      return (
        <DefaultCell key={key} minWidth={minWidth} maxWidth={maxWidth}>
          {item[key] || '-'}
        </DefaultCell>
      );
    }
  }
};

const UploadResultsStep = ({ importedAdmins }: { importedAdmins: any }) => {
  return (
    <>
      {importedAdminsTypes.map((importedAdminType: any) => {
        const admins = importedAdmins.filter(
          (importedAdmin: any) =>
            importedAdmin.status === importedAdminType.key,
        );

        return (
          <Collapsible
            key={importedAdminType.key}
            className={styles.results}
            openedClassName={cn(styles.results, styles.resultsOpened)}
            transitionTime={150}
            triggerTagName="div"
            trigger={
              <UploadResultHeader
                triggerIconClassName={styles.resultsTriggerIcon}
                iconName={importedAdminType.iconName}
                iconColor={importedAdminType.iconColor}
                title={importedAdminType.title}
                rowsCount={admins.length}
              />
            }
          >
            {admins && admins.length > 0 && (
              <Table
                className={styles.resultsTable}
                data={admins}
                columns={getAdminsTableColumns()}
                cellRenderer={cellRenderer}
              />
            )}
          </Collapsible>
        );
      })}
    </>
  );
};

export default React.memo(UploadResultsStep) as any;
